import { render, staticRenderFns } from "./AbsencesTable.vue?vue&type=template&id=0d6ca4e5&scoped=true"
import script from "./AbsencesTable.vue?vue&type=script&lang=js"
export * from "./AbsencesTable.vue?vue&type=script&lang=js"
import style0 from "./AbsencesTable.vue?vue&type=style&index=0&id=0d6ca4e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ca4e5",
  null
  
)

export default component.exports